export default __webpack_public_path__ + "static/media/img--interiors-7.4ba02f22.jpg";